export type { PreferredLanguageResponse } from '~/shared/hooks/usePreferredLanguage';
export { usePreferredLanguage } from '~/shared/hooks/usePreferredLanguage';
